import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminShell from './AdminShell';
import { getAdminBookings } from '../../api/client';

const STATUS_LABELS = {
  pending: 'Ожидает',
  confirmed: 'Подтверждено',
  paid: 'Оплачено',
  cancelled: 'Отменено',
  completed: 'Завершено',
};

function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAdminBookings({ status: filter || undefined, limit: 100 })
      .then(setBookings)
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <AdminShell title="Бронирования">
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {['', 'pending', 'confirmed', 'paid', 'cancelled'].map(s => (
          <button
            key={s}
            onClick={() => setFilter(s)}
            className={`btn btn-${filter === s ? 'primary' : 'secondary'}`}
            style={{ padding: '8px 16px', fontSize: 14 }}
          >
            {s === '' ? 'Все' : STATUS_LABELS[s]}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" /></div>
      ) : (
        <div className="card">
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Заявка</th>
                  <th>Гость</th>
                  <th>Квартира</th>
                  <th>Заезд</th>
                  <th>Выезд</th>
                  <th>Ночей</th>
                  <th>Сумма, ₽</th>
                  <th>Оплата</th>
                  <th>Статус</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {bookings.length === 0 && (
                  <tr>
                    <td colSpan={10} style={{ textAlign: 'center', color: 'var(--gray-400)', padding: 40 }}>
                      Бронирований нет
                    </td>
                  </tr>
                )}
                {bookings.map(b => (
                  <tr key={b.id}>
                    <td>
                      <Link to={`/admin/bookings/${b.id}`} style={{ fontWeight: 700 }}>
                        {b.booking_ref}
                      </Link>
                    </td>
                    <td>
                      <div style={{ fontWeight: 600 }}>{b.guest_name}</div>
                      <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>{b.guest_phone}</div>
                    </td>
                    <td>{b.apartment_name}</td>
                    <td>{formatDate(b.check_in)}</td>
                    <td>{formatDate(b.check_out)}</td>
                    <td style={{ textAlign: 'center' }}>{b.nights}</td>
                    <td style={{ fontWeight: 700 }}>{new Intl.NumberFormat('ru-RU').format(b.total_price_rub)}</td>
                    <td>
                      <span className={`badge badge-${b.payment_status === 'paid' ? 'paid' : 'pending'}`}>
                        {b.payment_status === 'paid' ? 'Оплачено' : 'Не оплачено'}
                      </span>
                    </td>
                    <td>
                      <span className={`badge badge-${b.status}`}>{STATUS_LABELS[b.status] || b.status}</span>
                    </td>
                    <td>
                      <Link to={`/admin/bookings/${b.id}`} className="btn btn-secondary" style={{ padding: '6px 12px', fontSize: 13 }}>
                        Открыть
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </AdminShell>
  );
}